// axios base file
import axios from 'axios';

export default axios.create({
    baseURL : "https://vast-pear-bear-shoe.cyclic.app" 
});